// Analytics Dashboard Mock Data
// Realistic data for a Growth plan Max OS Cloud customer

const generateDailyMessages = (days, baseCount, variance) => {
  const data = [];
  const now = new Date();
  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);
    const dayOfWeek = date.getDay();
    const weekendFactor = (dayOfWeek === 0 || dayOfWeek === 6) ? 0.6 : 1.0;
    const randomFactor = 0.8 + Math.random() * 0.4;
    const count = Math.round(baseCount * weekendFactor * randomFactor);
    data.push({
      date: date.toISOString().split('T')[0],
      day: date.toLocaleDateString('en-US', { weekday: 'short' }),
      messages: count,
      received: Math.round(count * 0.55),
      sent: Math.round(count * 0.45),
    });
  }
  return data;
};

const generateResponseTimes = (days) => {
  const data = [];
  const now = new Date();
  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);
    data.push({
      date: date.toISOString().split('T')[0],
      day: date.toLocaleDateString('en-US', { weekday: 'short' }),
      avgMs: Math.round(800 + Math.random() * 1200),
      p95Ms: Math.round(1800 + Math.random() * 2200),
    });
  }
  return data;
};

// 30 days of message volume data
export const messagesLast30Days = generateDailyMessages(30, 1200, 0.3);

// 7 days summary
export const messagesLast7Days = messagesLast30Days.slice(-7);

// Response time trends (30 days)
export const responseTimeTrend = generateResponseTimes(30);
export const responseTimeTrend7Days = responseTimeTrend.slice(-7);

// Channel distribution
export const channelDistribution = [
  { name: 'WhatsApp', value: 42, color: '#25D366' },
  { name: 'Telegram', value: 28, color: '#0088cc' },
  { name: 'Email', value: 18, color: '#EA4335' },
  { name: 'Discord', value: 8, color: '#5865F2' },
  { name: 'Slack', value: 4, color: '#4A154B' },
];

// Top intents / most frequent queries
export const topIntents = [
  { name: 'Customer Support', count: 342, percentage: 28.5 },
  { name: 'Order Status', count: 256, percentage: 21.3 },
  { name: 'Product Info', count: 198, percentage: 16.5 },
  { name: 'Appointment', count: 167, percentage: 13.9 },
  { name: 'FAQ / General', count: 125, percentage: 10.4 },
  { name: 'Complaints', count: 68, percentage: 5.7 },
  { name: 'Feedback', count: 44, percentage: 3.7 },
];

// KPI summary data
export const kpiSummary = {
  // Messages
  messagesToday: 1247,
  messagesTodayTrend: 12.5, // % change from yesterday
  messagesWeek: 8234,
  messagesWeekTrend: 8.3,
  messagesMonth: 34567,
  messagesMonthTrend: 15.2,

  // Response time
  avgResponseTime: 1.2, // seconds
  avgResponseTrend: -0.3, // negative = improvement
  p95ResponseTime: 2.8, // seconds

  // Resolution rate
  autoResolutionRate: 78.5, // percentage
  autoResolutionTrend: 3.2,
  escalatedCount: 47,

  // Customer satisfaction
  npsScore: 72,
  npsTrend: 5,
  satisfactionRate: 94.2,
  totalRatings: 1834,

  // Cost savings
  hoursSaved: 156,
  hoursSavedTrend: 22,
  hourlyRate: 45, // USD
  costSaved: 7020, // USD
  costSavedTrend: 18.5,

  // Channel breakdown (absolute numbers)
  channelMessages: {
    whatsapp: 14567,
    telegram: 9702,
    email: 6234,
    discord: 2771,
    slack: 1393,
  },
};

// Agent performance data
export const agentPerformance = [
  {
    id: 'agent-1',
    name: 'Primary Agent',
    role: 'General Operations',
    messages: 28456,
    avgResponseTime: 1.1,
    resolutionRate: 82.3,
    status: 'active',
  },
  {
    id: 'agent-2',
    name: 'Support Agent',
    role: 'Customer Support',
    messages: 6211,
    avgResponseTime: 1.4,
    resolutionRate: 71.8,
    status: 'active',
  },
];

// Hourly distribution (messages by hour of day)
export const hourlyDistribution = [
  { hour: '00', messages: 45 },
  { hour: '01', messages: 32 },
  { hour: '02', messages: 28 },
  { hour: '03', messages: 22 },
  { hour: '04', messages: 18 },
  { hour: '05', messages: 35 },
  { hour: '06', messages: 89 },
  { hour: '07', messages: 156 },
  { hour: '08', messages: 234 },
  { hour: '09', messages: 312 },
  { hour: '10', messages: 298 },
  { hour: '11', messages: 276 },
  { hour: '12', messages: 198 },
  { hour: '13', messages: 224 },
  { hour: '14', messages: 267 },
  { hour: '15', messages: 289 },
  { hour: '16', messages: 245 },
  { hour: '17', messages: 198 },
  { hour: '18', messages: 167 },
  { hour: '19', messages: 145 },
  { hour: '20', messages: 123 },
  { hour: '21', messages: 98 },
  { hour: '22', messages: 76 },
  { hour: '23', messages: 54 },
];

// Weekly comparison data
export const weeklyComparison = [
  { week: 'Week 1', messages: 7234, resolution: 74.2, satisfaction: 92.1 },
  { week: 'Week 2', messages: 7856, resolution: 75.8, satisfaction: 93.4 },
  { week: 'Week 3', messages: 8012, resolution: 77.1, satisfaction: 93.8 },
  { week: 'Week 4', messages: 8234, resolution: 78.5, satisfaction: 94.2 },
];

// Export all data as a single object for convenience
export const analyticsData = {
  messagesLast30Days,
  messagesLast7Days,
  responseTimeTrend,
  responseTimeTrend7Days,
  channelDistribution,
  topIntents,
  kpiSummary,
  agentPerformance,
  hourlyDistribution,
  weeklyComparison,
};

export default analyticsData;
